export const FIND_SPOT_LISTS_FAILURE = 'FIND_SPOT_LISTS_FAILURE';

export const findSpotListsFailure = ( payload: Error ) => ({
    type: FIND_SPOT_LISTS_FAILURE,
    payload,
});